var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-nav"},[_c('div',{staticClass:"nav-left"},[_vm._v(_vm._s(_vm.left))]),_c('div',{staticClass:"nav-right",on:{"click":function($event){return _vm.goto(_vm.path)}}},[_vm._v("更多")])])}
var staticRenderFns = []

export { render, staticRenderFns }